<template>
  <div class="text-position">
    <template v-if="currentPrivacy == 1">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <v-icon class="mr-1">{{ canSeeLabel[0].icon }}</v-icon>
            <span>{{ canSeeLabel[0].text }}</span>
          </div>
        </template>
        <span>{{ canSeeLabel[0].note }}</span>
      </v-tooltip>
    </template>
    <template v-else-if="currentPrivacy == 2">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <v-icon class="mr-1">{{ canSeeLabel[1].icon }}</v-icon>
            <span>{{ canSeeLabel[1].text }}</span>
          </div>
        </template>
        <div class="text-wrap w-40 break-normal">
          <span>{{ $t('market.renter_market') }}</span>
          <span v-for="(market, index) in currentMarkets" :key="index">{{ `${index == 0 ? ' ' :
            ''}${market.name}${index + 1 < currentMarkets.length ? ', ' : ' ' }`}}</span>
              <span>{{ $t('project.will_see_this_post') }}</span>
        </div>
      </v-tooltip>
    </template>
  </div>
</template>

<script>
export default {
  name: "PostPrivacyTooltip",
  data() {
    return {
      canSeeLabel: []
    };
  },
  created() {
    this.canSeeLabel = [
      {
        value: 1,
        text: this.$t('project.see_all_market'),
        note: this.$t('project.all_market_in_project'),
        icon: "mdi-earth"
      },
      {
        value: 2,
        text: this.$t('project.see_only_market'),
        note: this.$t('project.select_post_market_only'),
        icon: "mdi-account-group"
      }
    ];
  },
  computed: {
    currentMarkets() {
      let res = [];
      if (this.post && this.post.markets && this.post.markets.length) {
        res = this.post.markets;
      } else if (this.markets && this.markets.length) {
        res = this.markets;
      }
      return res;
    },
    currentPrivacy() {
      let res = 0;
      if (this.post && this.post.privacy) {
        res = this.post.privacy;
      } else if (this.privacy) {
        res = this.privacy;
      }
      return res;
    }
  },
  props: { post: Object, privacy: Number, markets: Array }
};
</script>

<style lang="scss" scoped>
.text-position {
  cursor: default;
  font-size: 15px;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  .v-icon {
    color: gray;
    font-size: 12px;
  }

  span {
    color: gray;
    font-size: 12px;
  }
}
</style>
